import React, { lazy } from 'react';
import { Debts } from '@datanomik/commons-ui/icons';

const DebtsOverviewPage = lazy(() =>
  import('./overview/DebtsOverviewPage').then((m) => ({ default: m.DebtsOverviewPage })),
);

const MyDebtsPage = lazy(() =>
  import('./my-debts/MyDebtsPage').then((m) => ({ default: m.MyDebtsPage })),
);

const DebtSchedulePage = lazy(() =>
  import('./debt-schedule/DebtSchedulePage').then((m) => ({ default: m.DebtSchedulePage })),
);

const NewDebtPage = lazy(() =>
  import('./new-debt/NewDebtPage').then((m) => ({ default: m.NewDebtPage })),
);

export const getDebtsRoutes = () => [
  {
    path: '',
    key: 'debts',
    label: 'Dívidas',
    description: 'Visão consolidada de dívidas por instituição, tipo e cronograma.',
    element: <DebtsOverviewPage />,
    icon: <Debts />,
  },
  {
    path: 'new-debt',
    key: 'debts-new-debt',
    label: 'Nova dívida',
    element: <NewDebtPage />,
    showInMenu: false,
    hiddenPageTitle: true,
    hideBackButton: true,
  },
  {
    path: 'my-debts',
    key: 'debts-my-debts',
    label: 'Dívidas',
    description: 'Visão consolidada de dívidas por instituição, tipo e cronograma.',
    element: <MyDebtsPage />,
    icon: <Debts />,
  },
  {
    path: 'my-debts/:id/schedule',
    key: 'debts-schedule',
    label: 'Cronograma',
    element: <DebtSchedulePage />,
    hiddenPageTitle: true,
    hideBackButton: true,
  },
];
